import { render, staticRenderFns } from "./PlantSelect.vue?vue&type=template&id=b6ef159c&"
import script from "./PlantSelect.vue?vue&type=script&lang=js&"
export * from "./PlantSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports